import React from 'react';

import styles from './UsersPage.module.scss';

type Props = {
  children: React.ReactNode;
};

export const UsersPageWrapper: React.FC<Props> = ({ children }) => {
  return <div className={styles.UsersPage__Wrapper}>{children}</div>;
};
